import { Button, useTheme } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import type { IPrimaryButton } from './PrimaryButton.types';

const PrimaryButton: FC<IPrimaryButton> = ({ text, ...rest }) => {
  const themeHook = useTheme();

  return (
    <Button
      size="large"
      {...rest}
      data-test={rest['data-test']}
      sx={[themeHook.mixins.primaryButtonStyle, ...castArray(rest.sx)]}
    >
      {text}
    </Button>
  );
};

export default PrimaryButton;
